import { render, staticRenderFns } from "./MidCategoryAddModal.vue?vue&type=template&id=267a7640&scoped=true"
import script from "./MidCategoryAddModal.vue?vue&type=script&lang=js"
export * from "./MidCategoryAddModal.vue?vue&type=script&lang=js"
import style0 from "./MidCategoryAddModal.vue?vue&type=style&index=0&id=267a7640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a7640",
  null
  
)

export default component.exports